import { createReducer, on } from "@ngrx/store";
import { resetSearchState, setSearchDropdownItems, setSearchText, showSearchBar } from "./search-bar.actions";
import { initialSearchState } from "./search-bar.state";

const _searchBarReducer = createReducer(
  initialSearchState,
  on(setSearchText, (state, action) => {
    return {
      ...state,
      searchText: action.searchText
    };
  }),
  on(showSearchBar, (state, action) => {
    return {
      ...state,
      showSearchBar: action.show
    }
  }),
  on(setSearchDropdownItems, (state, action) => {
    return {
      ...state,
      dropdownItems: action?.dropdownItems
    }
  }),
  on(resetSearchState, (state) => {
    return {
      ...state,
      searchText: undefined,
      dropdownItems: {dashboard: '', items: []}
    };
  })
);

export const searchBarReducer = (state, action) => {
  return _searchBarReducer(state, action);
};